<nav class="sso-sign-in-header d-flex" xmlns="http://www.w3.org/1999/html">
  <img
    alt="soregies_logo"
    class="img-logo"
    src="https://static.soregies.fr/logos/Groupe+Sore%CC%81gies/Logos+Groupe+Soregies/Logo+Groupe+Soregies/Logo+Groupe+Soregies.png"
  />
</nav>
<div class="sso-sign-in-container">
  <h1 class="title">Chargement en cours...</h1>
</div>
